/**
 * Decorator to validate if the user has the permissions required to execute the decorated method
 * The method is executed only if the user has the right permission(s)
 * Sample use:
 *
 * @Secure(PERMISSION.INVISION_DESKTOP_DATA_ANALYST)
 * getRules(): any {
 *   // method body
 * }
 *
 * // in this scenario the user needs 2 permissions to execute the method
 *
 * @Secure(PERMISSION.INVISION_DESKTOP_DATA_ANALYST)
 * @Secure(Permission.INVISION_DESKTOP_APPROVER)
 * doSomething(): any {
 *   // method body
 * }
 */
import {CoreModule} from '../core.module';
import {PermissionService} from '../service/permission.service';

export function Secure(permission: string) {
	return function (target: any, key: string | symbol, descriptor: PropertyDescriptor): any {
		const original = descriptor.value;

		descriptor.value = function (...args: any[]) {
			const permissionService = CoreModule.injector.get<PermissionService>(PermissionService);
			const allow = permissionService.hasPermission(permission);

			if (allow) {
				const result = original.apply(this, args);
				return result;
			} else {
				return null;
			}
		};

		return descriptor;
	};
}
